/* ==========================================================================
   DR.CARE — JS de interacción del tema Liquid. El markup ya viene renderizado
   por el servidor (Liquid) con datos reales de Shopify; este archivo SOLO
   gobierna comportamiento: carrusel del hero, tabs, carrusel de categorías,
   armador de kit, mega menú mobile, buscador predictivo, quick view,
   wishlist, drawer del carro (AJAX real /cart.js). Nada de Lenis.
   ========================================================================== */
(function () {
  "use strict";

  var S = window.DR_SETTINGS || {};

  function clp(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return "$" + n.toLocaleString("es-CL");
  }
  // /search/suggest.json (a diferencia de /products/{handle}.js y /cart.js) entrega el
  // precio como string decimal REAL, sin el ×100 de Shopify — gotcha propio, verificado
  // contra el endpoint en vivo. Nunca pasar ese valor por clp().
  function clpPlain(pesos) {
    var n = Math.round(Number(pesos) || 0);
    return "$" + n.toLocaleString("es-CL");
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function toast(msg) {
    var el = document.getElementById("drToast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("is-visible");
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove("is-visible"); }, 2200);
  }
  window.DrToast = toast;

  // -------------------------------------------------- subrayado de títulos --
  function ensureUnderlines() {
    qsa(".section-title").forEach(function (el) {
      if (el.querySelector("svg.underline")) return;
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("class", "underline");
      svg.setAttribute("viewBox", "0 0 220 10");
      svg.innerHTML = '<path d="M2 6 C 60 2, 160 2, 218 6" />';
      el.appendChild(svg);
    });
  }

  // ------------------------------------------ evento único de cambio de carro --
  // Hay varios caminos que tocan el carro (ficha, pack, combo de envío, drawer,
  // /cart, vista rápida). En vez de avisar en cada uno, se envuelve fetch: toda
  // llamada exitosa a /cart/add|change|update|clear.js dispara "cart:updated"
  // con el carro fresco. La barra de envío de la ficha se re-renderiza con eso
  // (16-09: "cuando agregó las cosas al carro no se corrige lo que falta").
  (function () {
    if (window.__drCartFetchWrapped || typeof window.fetch !== "function") return;
    window.__drCartFetchWrapped = true;
    var raw = window.fetch;
    var re = /\/cart\/(add|change|update|clear)\.js(\?|$)/;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = raw.apply(this, arguments);
      if (re.test(url)) {
        p.then(function (r) {
          if (!r.ok) return;
          raw((S.routes && S.routes.cart) || "/cart.js", { credentials: "same-origin" }).then(function (x) { return x.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  })();

  // ---------------------------------------------- aparición al hacer scroll --
  // Portado de la maqueta (main.js initReveal). Faltaba en el tema: los
  // ítems de la tira de servicios llevan .reveal y quedaban en opacity 0
  // para siempre (detectado 16-09 en la captura de la home).
  function initReveal() {
    var targets = qsa(".reveal, .section-title");
    if (!("IntersectionObserver" in window) || !targets.length) {
      targets.forEach(function (t) { t.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    targets.forEach(function (t) { io.observe(t); });
  }

  // ------------------------------------------------- carrusel de ofertas --
  function initPromoCarousel() {
    var root = document.getElementById("drPromo");
    if (!root || !root.classList.contains("promo-banner--carousel")) return;
    var slides = qsa(".promo-banner__slide", root), dots = qsa(".promo-banner__dot", root);
    if (slides.length < 2) return;
    var cur = 0, timer = null, every = (parseInt(root.getAttribute("data-interval"), 10) || 6) * 1000;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === cur); });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === cur); d.setAttribute("aria-selected", k === cur ? "true" : "false"); });
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { go(cur + 1); }, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d) { d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-index"), 10) || 0); start(); }); });
    root.addEventListener("mouseenter", stop); root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop); root.addEventListener("focusout", start);
    var sx = 0, sy = 0;
    root.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; stop(); }, { passive: true });
    root.addEventListener("touchend", function (e) { var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? cur + 1 : cur - 1); start(); }, { passive: true });
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });
    start();
  }

  // ------------------------------------------------------------ hero -------
  function initHero() {
    var root = document.getElementById("drHero");
    if (!root) return;
    var slides = qsa(".hero__slide", root);
    var dots = qsa(".hero__dot", root);
    if (slides.length < 2) return;
    var idx = 0;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === idx;
        s.classList.toggle("is-active", active);
        s.setAttribute("aria-hidden", active ? "false" : "true");
      });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
    }
    var prevBtn = qs(".hero__arrow--prev", root);
    var nextBtn = qs(".hero__arrow--next", root);
    if (prevBtn) prevBtn.addEventListener("click", function () { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { show(idx + 1); });
    dots.forEach(function (d) {
      d.addEventListener("click", function () { show(parseInt(d.getAttribute("data-dot"), 10)); });
    });
    // Swipe en touch (QA móvil 15-09: las flechas se ocultan en móvil y los
    // puntos eran el único control). Horizontal > 40px y más horizontal que
    // vertical para no robar el scroll.
    var tx = null, ty = null;
    root.addEventListener("touchstart", function (e) { var t = e.touches[0]; tx = t.clientX; ty = t.clientY; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (tx === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - tx, dy = t.clientY - ty; tx = ty = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    if (!reduce) {
      var timer = setInterval(function () { show(idx + 1); }, 6000);
      root.addEventListener("touchstart", function () { clearInterval(timer); }, { passive: true });
      root.addEventListener("mouseenter", function () { clearInterval(timer); });
      root.addEventListener("mouseleave", function () { timer = setInterval(function () { show(idx + 1); }, 6000); });
      root.addEventListener("focusin", function () { clearInterval(timer); });
    }
  }

  // --------------------------------------------------- tabs de selección ---
  function initTabs() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-tab]");
      if (!btn) return;
      var tabsBox = btn.closest(".tabs");
      if (!tabsBox) return;
      var container = tabsBox.closest(".container") || tabsBox.parentElement;
      qsa(".tab", tabsBox).forEach(function (t) { t.classList.remove("is-active"); t.setAttribute("aria-selected", "false"); });
      btn.classList.add("is-active");
      btn.setAttribute("aria-selected", "true");
      var target = btn.getAttribute("data-tab");
      qsa(".dr-tab-panel", container).forEach(function (p) {
        p.hidden = p.getAttribute("data-tab-panel") !== target;
      });
    });
  }

  // --------------------------------------- carruseles horizontales (flechas) --
  function initCarouselArrows() {
    document.addEventListener("click", function (e) {
      var prev = e.target.closest("[data-carousel-prev]");
      var next = e.target.closest("[data-carousel-next]");
      var btn = prev || next;
      if (!btn) return;
      var id = btn.getAttribute(prev ? "data-carousel-prev" : "data-carousel-next");
      var vp = document.getElementById(id);
      if (!vp) return;
      var step = Math.min(vp.clientWidth * 0.9, 600);
      vp.scrollBy({ left: prev ? -step : step, behavior: "smooth" });
    });
  }

  // ------------------------------ "Llega hoy / Llega mañana" (Same Day) ----
  // 29-09 (Javiera). El corte es a las 10:00 de Chile, de lunes a viernes y sin feriados, así que
  // el cálculo va en JS con la zona America/Santiago: el HTML de Shopify se cachea y un texto
  // escrito en Liquid quedaría pegado con la hora de la primera visita.
  function initSameDay() {
    var slots = qsa("[data-sameday]");
    if (!slots.length) return;
    var fer = String(S.feriados || "").replace(/\s/g, "").split(",").filter(Boolean);
    function parts(d) {
      var f = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Santiago", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hour12: false, weekday: "short" }).formatToParts(d);
      var o = {};
      f.forEach(function (p) { o[p.type] = p.value; });
      return { iso: o.year + "-" + o.month + "-" + o.day, hour: parseInt(o.hour, 10), wd: o.weekday };
    }
    function habil(p) { return p.wd !== "Sat" && p.wd !== "Sun" && fer.indexOf(p.iso) === -1; }
    var now = new Date(), hoy = parts(now);
    var txt;
    if (habil(hoy) && hoy.hour < 10) {
      txt = "Llega hoy";
    } else {
      var d = new Date(now.getTime()), p = null;
      for (var i = 1; i <= 7; i++) {
        d = new Date(now.getTime() + i * 86400000);
        p = parts(d);
        if (habil(p)) break;
      }
      var dias = { Mon: "el lunes", Tue: "el martes", Wed: "el miércoles", Thu: "el jueves", Fri: "el viernes" };
      var manana = parts(new Date(now.getTime() + 86400000));
      txt = (p && p.iso === manana.iso) ? "Llega mañana" : "Llega " + (dias[p && p.wd] || "el próximo día hábil");
    }
    slots.forEach(function (el) {
      el.textContent = txt;
      el.hidden = false;
      el.setAttribute("title", "Despacho Same Day en " + (S.shippingRegionLabel || "RM") + ": pedidos hasta las 10:00, de lunes a viernes");
    });
  }


  // ------------------------- campaña Cyber: cuenta regresiva ----
  // El interruptor (¿está corriendo la campaña?) lo resuelve el script en línea de theme.liquid,
  // que pone `cyber-on` en el <html> ANTES del primer pintado. Acá solo va lo que tiene que
  // moverse: el reloj de la barra de arriba y el "termina en" de la ficha. Si la campaña no está
  // corriendo no se arma ningún intervalo.
  function initCyber() {
    var C = S.cyber || {};
    var root = document.documentElement;
    if (!C.on) return;

    function chile(d) {
      var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(d || "").trim());
      if (!m) return null;
      var base = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
      for (var i = 0, t = base; i < 2; i++) {
        var o = {};
        new Intl.DateTimeFormat("en-CA", { timeZone: "America/Santiago", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false })
          .formatToParts(new Date(t)).forEach(function (p) { o[p.type] = p.value; });
        t += base - Date.UTC(+o.year, +o.month - 1, +o.day, +(o.hour === "24" ? "00" : o.hour), +o.minute);
      }
      return t;
    }

    var fin = chile(C.hasta);
    if (fin === null) return;
    var reloj = qsa("[data-cyber-clock]"), cortos = qsa("[data-cyber-short]");
    if (!reloj.length && !cortos.length) return;
    var dd = qsa("[data-cyber-d]"), hh = qsa("[data-cyber-h]"), mm = qsa("[data-cyber-m]"), ss = qsa("[data-cyber-s]");

    function dos(n) { return n < 10 ? "0" + n : String(n); }
    var timer = null;
    function tick() {
      var falta = fin - Date.now();
      if (falta <= 0) {
        // Se acabó sin que nadie recargue: el sitio se desviste solo.
        root.classList.remove("cyber-on");
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      var s = Math.floor(falta / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      s = s % 60;
      dd.forEach(function (e) { e.textContent = dos(d); });
      hh.forEach(function (e) { e.textContent = dos(h); });
      mm.forEach(function (e) { e.textContent = dos(m); });
      ss.forEach(function (e) { e.textContent = dos(s); });
      // En la ficha se lee, no se cronometra: "2 días 14 h" dice más que 8 números corriendo.
      var corto = d > 0 ? (d + (d === 1 ? " día " : " días ") + h + " h") : (h > 0 ? (h + " h " + dos(m) + " min") : (m + " min " + dos(s) + " s"));
      cortos.forEach(function (e) { e.textContent = corto; });
      reloj.forEach(function (e) { e.hidden = false; });
    }
    function arrancar() {
      if (timer) return;
      tick();
      timer = setInterval(tick, 1000);
    }
    if (root.classList.contains("cyber-on")) arrancar();
    // Si la campaña parte estando la pestaña abierta, el interruptor avisa y el reloj se suma.
    document.addEventListener("dr:cyber-on", arrancar);
  }


  // ------------------------- cupón de Mercado Pago ----
  // Dos cosas: copiar el código con un clic, y esconder el bloque cuando el carro todavía no
  // llega al mínimo de la campaña. Lo segundo importa: la promo pide compras desde $30.000 y
  // prometer un descuento que el comprador no va a poder usar es peor que no decir nada.
  // En la ficha y en la página del carro el monto ya lo resolvió Liquid; en el drawer no, porque
  // el carro se arma por fetch, así que el mínimo se revisa acá cada vez que cambia.
  function initPromoMp() {
    var M = S.mp || {};
    if (!M.on) return;
    var min = parseInt(M.minimo, 10) || 0;

    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-mp-copy]");
      if (!b) return;
      e.preventDefault();
      var caja = b.closest("[data-mp-promo]");
      var code = caja && caja.querySelector("[data-mp-code]");
      var txt = code ? code.textContent.trim() : (M.cupon || "");
      if (!txt) return;
      function listo() {
        var antes = b.textContent;
        b.textContent = "Copiado";
        b.classList.add("is-ok");
        setTimeout(function () { b.textContent = antes; b.classList.remove("is-ok"); }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(listo, listo);
      } else {
        // Safari viejo y vistas dentro de apps no tienen clipboard: se cae a seleccionar el texto.
        var r = document.createRange();
        r.selectNodeContents(code);
        var sel = window.getSelection();
        sel.removeAllRanges(); sel.addRange(r);
        try { document.execCommand("copy"); } catch (err) {}
        listo();
      }
    });

    // El drawer: mostrar/esconder según el subtotal real (viene en centavos, CLP se guarda x100).
    function revisar(centavos) {
      var pesos = Math.round((centavos || 0) / 100);
      qsa("#drCartDrawer [data-mp-promo], .cart-drawer [data-mp-promo]").forEach(function (el) {
        el.style.display = pesos >= min ? "" : "none";
      });
    }
    document.addEventListener("dr:cart", function (e) { if (e.detail) revisar(e.detail.total_price); });
    // Por si el carro ya estaba armado al cargar.
    if (document.querySelector("[data-mp-promo]")) {
      fetch((S.routes && S.routes.cart) || "/cart.js", { credentials: "same-origin" })
        .then(function (x) { return x.json(); })
        .then(function (c) { revisar(c.total_price); })
        .catch(function () {});
    }
  }

  // ------------------------- html.is-scrolled: pliega la huincha bajo el header ----
  function initScrolledFlag() {
    var root = document.documentElement, last = null;
    function tick() {
      var on = window.scrollY > 90;
      if (on !== last) { last = on; root.classList.toggle("is-scrolled", on); }
    }
    window.addEventListener("scroll", tick, { passive: true });
    tick();
  }

  // ------------------------- filas con scroll lateral: arrastre + rueda ----
  // 21-09: en escritorio con mouse no hay forma obvia de desplazar una fila
  // horizontal (sin barra visible y la rueda mueve la página). Arrastre con
  // el mouse y rueda vertical → lateral cuando la fila puede seguir moviéndose.
  function initDragScroll() {
    qsa("[data-drag-scroll]").forEach(function (row) {
      var down = false, moved = false, startX = 0, startLeft = 0;
      row.addEventListener("mousedown", function (e) {
        if (e.button !== 0) return;
        e.preventDefault(); // que el arrastre no seleccione texto de la página
        down = true; moved = false; startX = e.pageX; startLeft = row.scrollLeft;
      });
      window.addEventListener("mousemove", function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        // La clase (con pointer-events:none en las calugas) SOLO cuando hay arrastre real:
        // ponerla desde el mousedown hacía que el click normal cayera en la fila y no en el link.
        if (Math.abs(dx) > 4 && !moved) { moved = true; row.classList.add("is-dragging"); }
        if (moved) { e.preventDefault(); row.scrollLeft = startLeft - dx; }
      });
      window.addEventListener("mouseup", function () {
        if (!down) return;
        down = false; row.classList.remove("is-dragging");
      });
      // si hubo arrastre, el click no navega
      row.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      row.addEventListener("wheel", function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 0) return;
        var next = row.scrollLeft + e.deltaY;
        if ((e.deltaY > 0 && row.scrollLeft < max) || (e.deltaY < 0 && row.scrollLeft > 0)) {
          e.preventDefault();
          row.scrollLeft = Math.max(0, Math.min(max, next));
        }
      }, { passive: false });
    });
  }

  // --------------------------------------------------------- arma tu kit ---
  function initScenarios() {
    document.addEventListener("click", function (e) {
      var card = e.target.closest("[data-scenario]");
      if (card) {
        var section = card.closest(".section");
        var panel = qs(".scenario-panel", section);
        var source = qs('[data-scenario-source="' + card.getAttribute("data-scenario") + '"]', section);
        if (!panel || !source) return;
        var wasOpen = card.classList.contains("is-open");
        qsa("[data-scenario]", section).forEach(function (c) { c.classList.remove("is-open"); });
        if (wasOpen) {
          panel.classList.remove("is-open");
          panel.innerHTML = "";
          return;
        }
        card.classList.add("is-open");
        panel.innerHTML = source.innerHTML;
        panel.classList.add("is-open");
        panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
        return;
      }
      var addAll = e.target.closest("[data-scenario-add-all]");
      if (addAll) {
        var itemsBox = addAll.closest(".scenario-panel__foot").previousElementSibling;
        var variantIds = qsa(".scenario-item .v", itemsBox).map(function (v) { return v.textContent.trim(); }).filter(Boolean);
        if (!variantIds.length) return;
        addMultipleToCart(variantIds.map(function (id) { return { id: id, quantity: 1 }; })).then(function () {
          toast("Kit agregado al carro");
          openCartDrawer();
        });
      }
    });
  }

  // ---------------------------------------------------------- mobile menu --
  function initMobileMenu() {
    var menu = document.getElementById("drMobileMenu");
    if (!menu) return;
    document.addEventListener("click", function (e) {
      var openBtn = document.getElementById("drBtnOpenMenu");
      if (e.target.closest("#drBtnOpenMenu")) {
        menu.classList.add("is-open");
        menu.setAttribute("aria-hidden", "false");
        if (openBtn) openBtn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
      }
      if (e.target.closest("[data-close-menu]")) {
        menu.classList.remove("is-open");
        menu.setAttribute("aria-hidden", "true");
        if (openBtn) openBtn.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
      }
      var accBtn = e.target.closest(".mobile-accordion__btn");
      if (accBtn) {
        var acc = accBtn.closest(".mobile-accordion");
        if (!acc || !acc.querySelector(".mobile-accordion__panel")) return; // link plano (sin hijos), navega normal
        // 21-09: el nombre de la categoría padre es un link (va a la colección); solo el chevron abre el panel
        if (e.target.closest(".mobile-accordion__go")) return;
        e.preventDefault();
        var wasOpen = acc.classList.contains("is-open");
        qsa(".mobile-accordion.is-open", menu).forEach(function (a) { a.classList.remove("is-open"); var b = a.querySelector(".mobile-accordion__btn"); if (b) b.setAttribute("aria-expanded", "false"); });
        if (!wasOpen) { acc.classList.add("is-open"); accBtn.setAttribute("aria-expanded", "true"); }
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        menu.classList.remove("is-open");
        menu.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    });
  }

  // -------------------------------------------------------------- buscador --
  function searchResultRow(p) {
    // /search/suggest.json: "image" es un string plano; "price" es decimal real
    // (no ×100) — distinto de /products/{handle}.js y /cart.js, ver clpPlain().
    var img = p.image || (p.featured_image && p.featured_image.url) || "";
    return (
      '<a class="search-result" href="' + p.url + '">' +
      '<img src="' + img + '" alt="" loading="lazy">' +
      '<span><span class="t" style="display:block">' + escHtml(p.title) + '</span>' +
      '<span class="m">' + escHtml(p.vendor || "") + (p.available === false ? " · Agotado" : "") + '</span></span>' +
      '<span class="p">' + clpPlain(p.price) + '</span></a>'
    );
  }
  function escHtml(s) {
    return (s || "").toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function renderSearchInto(box, query) {
    if (!box) return;
    if (!query || query.trim().length < 2) {
      box.innerHTML = '<div class="search-hint">Escribe al menos 2 letras. Ej: "cama", "silla de ruedas", "bastón", "oxímetro".</div>';
      return;
    }
    var url = "/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last";
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          box.innerHTML = '<div class="search-empty">No encontramos productos para "' + escHtml(query) + '". Escríbenos por WhatsApp y te ayudamos a encontrarlo.</div>';
          return;
        }
        box.innerHTML = products.map(searchResultRow).join("") +
          '<div style="padding:10px 8px"><a class="btn btn-ghost btn-block" href="' + S.routes.search + '?q=' + encodeURIComponent(query) + '&type=product">Ver todos los resultados para "' + escHtml(query) + '"</a></div>';
      })
      .catch(function () { box.innerHTML = '<div class="search-empty">No pudimos buscar en este momento.</div>'; });
  }
  function openSearchOverlay(prefill) {
    var overlay = document.getElementById("drSearchOverlay");
    var input = document.getElementById("drSearchOverlayInput");
    var box = document.getElementById("drSearchResultsBox");
    if (!overlay) return;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    input.value = prefill || "";
    renderSearchInto(box, input.value);
    setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearchOverlay() {
    var overlay = document.getElementById("drSearchOverlay");
    if (!overlay) return;
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  function initSearch() {
    var overlayInput = document.getElementById("drSearchOverlayInput");
    var headerInput = document.getElementById("drHeaderSearchInput");
    var box = document.getElementById("drSearchResultsBox");
    if (overlayInput && box) {
      overlayInput.addEventListener("input", debounce(function () { renderSearchInto(box, overlayInput.value); }, 150));
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("#btnHeaderSearch, #btnOpenSearchMobile, #drBtnOpenSearchMobile")) {
        var isHeaderBtn = !!e.target.closest("#btnHeaderSearch");
        if (isHeaderBtn && window.matchMedia && window.matchMedia("(min-width: 901px)").matches && headerInput) {
          // escritorio: la lupa busca de verdad (o enfoca el campo si está vacío)
          e.preventDefault();
          if (headerInput.value.trim()) { var f = headerInput.closest("form"); if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } }
          else headerInput.focus();
          return;
        }
        e.preventDefault();
        openSearchOverlay(headerInput ? headerInput.value : "");
      }
      if (e.target.closest("[data-close-search]")) closeSearchOverlay();
    });
    // 17-09 (José): en escritorio el buscador no "se abre": los resultados caen
    // debajo del mismo campo del header. La sábana queda solo para móvil.
    var desktop = window.matchMedia && window.matchMedia("(min-width: 901px)");
    var form = headerInput && headerInput.closest("form");
    var drop = null;
    function ensureDrop() {
      if (drop || !form) return drop;
      drop = document.createElement("div");
      drop.className = "search-drop"; drop.id = "drSearchDrop"; drop.hidden = true;
      drop.innerHTML = '<div class="search-results" id="drSearchDropBox"></div>';
      form.appendChild(drop);
      return drop;
    }
    function showDrop(q) {
      var d = ensureDrop(); if (!d) return;
      if (!q || q.trim().length < 2) { d.hidden = true; return; }
      d.hidden = false;
      renderSearchInto(document.getElementById("drSearchDropBox"), q);
    }
    function hideDrop() { if (drop) drop.hidden = true; }
    if (headerInput) {
      headerInput.addEventListener("focus", function () {
        if (desktop && desktop.matches) { showDrop(headerInput.value); } else { openSearchOverlay(headerInput.value); }
      });
      headerInput.addEventListener("input", debounce(function () { if (desktop && desktop.matches) showDrop(headerInput.value); }, 150));
      document.addEventListener("click", function (e) { if (form && !form.contains(e.target)) hideDrop(); });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeSearchOverlay(); hideDrop(); }
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        if (desktop && desktop.matches && headerInput) { headerInput.focus(); headerInput.select(); } else { openSearchOverlay(""); }
      }
    });
  }

  // ------------------------------------------------------------- wishlist --
  var FAV_KEY = "dr_favs";
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); } catch (e) { return []; }
  }
  function isFav(handle) { return getFavs().indexOf(handle) !== -1; }
  function toggleFav(handle) {
    var favs = getFavs();
    var i = favs.indexOf(handle);
    if (i === -1) favs.push(handle); else favs.splice(i, 1);
    localStorage.setItem(FAV_KEY, JSON.stringify(favs));
    updateFavCount();
    document.dispatchEvent(new CustomEvent("favs:change"));
    return i === -1;
  }
  function updateFavCount() {
    var el = document.getElementById("drFavCount");
    if (!el) return;
    var n = getFavs().length;
    el.textContent = n;
    el.hidden = n === 0;
  }
  function renderFavoritesPage() {
    var root = document.getElementById("drFavoritesRoot");
    if (!root) return;
    var handles = getFavs();
    var collUrl = (S.routes && S.routes.collections) || "/collections";
    if (!handles.length) {
      root.innerHTML = '<div class="cart-empty" style="padding:60px 20px">Todavía no has guardado productos en tu lista de deseos.<br><a href="' + collUrl + '" class="btn btn-primary" style="margin-top:16px">Ver productos</a></div>';
      return;
    }
    Promise.all(handles.map(function (h) {
      return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        root.innerHTML = '<div class="cart-empty" style="padding:60px 20px">Los productos guardados ya no están disponibles.<br><a href="' + collUrl + '" class="btn btn-primary" style="margin-top:16px">Ver productos</a></div>';
        return;
      }
      root.innerHTML = '<div class="grid-cards">' + products.map(favCardHtml).join("") + '</div>';
    });
  }
  document.addEventListener("favs:change", function () {
    if (document.getElementById("drFavoritesRoot")) renderFavoritesPage();
  });

  // Tarjeta de producto pintada en el cliente — réplica 1:1 de
  // snippets/drcare-product-card.liquid (que a su vez replica js/cards.js de la
  // maqueta), alimentada por /products/{handle}.js. Se usa en /favoritos.
  var ICON_HEART = '<svg class="dr-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7.5-4.6-10-9.3C.4 8.4 2 5 5.4 5c2 0 3.4 1.1 4.1 2.3.2.4.8.4 1 0C11.2 6.1 12.6 5 14.6 5 18 5 19.6 8.4 18 11.7 15.5 16.4 12 21 12 21z"/></svg>';
  var ICON_EYE = '<svg class="dr-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>';
  var ICON_VERIFIED = '<svg class="dr-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 2l2.4 1.3 2.7-.3 1.2 2.4 2.4 1.2-.3 2.7L22 12l-1.6 2.7.3 2.7-2.4 1.2-1.2 2.4-2.7-.3L12 22l-2.4-1.3-2.7.3-1.2-2.4-2.4-1.2.3-2.7L2 12l1.6-2.7-.3-2.7 2.4-1.2 1.2-2.4 2.7.3z"/><path d="M8.5 12.2l2.3 2.3 4.7-4.9"/></svg>';
  // 19-10 — ¿producto en preventa? Acá solo se puede mirar la ETIQUETA:
  // /products/{handle}.js NO entrega inventory_quantity ni la política de
  // inventario, así que desde el navegador no hay forma de saber si quedan
  // unidades (con CONTINUE puesto, `available` es true igual). Por eso el
  // criterio es conservador: un producto etiquetado PREVENTA no se agrega al
  // carro desde una tarjeta ni desde la vista rápida, se manda a la ficha, que
  // sí tiene el stock real y adjunta la marca "Entrega: Preventa — llega ...".
  // En Liquid (tarjetas server-rendered) sí se usa el criterio fino: etiqueta
  // + stock 0. Ver snippets/drcare-es-preventa.liquid.
  function esPreventa(p) {
    var t = p && p.tags;
    if (!t) return false;
    if (typeof t === "string") t = t.split(",");
    for (var i = 0; i < t.length; i++) {
      if (String(t[i]).toLowerCase().indexOf("preventa") !== -1) return true;
    }
    return false;
  }
  function favCardHtml(p) {
    var v = firstAvailableVariant(p) || {};
    var soldout = !p.available;
    var price = v.price || p.price || 0;
    var before = v.compare_at_price || 0;
    var pct = 0;
    if (before > price) {
      pct = Math.round((1 - price / before) * 100);
      if (pct < 15 || pct > 55) pct = 0;
    }
    var envio = (S.shippingThresholdCents || 0) > 0 && price >= S.shippingThresholdCents;
    var vendor = p.vendor || "";
    var importadas = (S.marcasImportadas || "").split(",").map(function (m) { return m.trim().toLowerCase(); }).filter(Boolean);
    var verified = importadas.indexOf(vendor.trim().toLowerCase()) !== -1;
    var n = parseInt(S.installments || 3, 10) || 3;
    var cuota = Math.ceil((price / n) / 1000) * 1000;
    var img = p.featured_image || (p.images && p.images[0]) || "";
    if (img && img.indexOf("width=") === -1) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=600";
    // 2ª foto para el hover: la primera distinta de la destacada (ver initCardHoverAlt).
    var alt = "";
    (p.images || []).some(function (u) {
      if (u && u !== (p.featured_image || "")) { alt = u + (u.indexOf("?") > -1 ? "&" : "?") + "width=600"; return true; }
      return false;
    });
    var pv = esPreventa(p);
    var badges = "";
    if (pv) badges = '<span class="card__badges"><span class="badge badge--preventa">PREVENTA</span></span>';
    else if (soldout) badges = '<span class="card__badges"><span class="badge badge--danger">Agotado</span></span>';
    else if (pct > 0 || envio) badges = '<span class="card__badges">' + (pct > 0 ? '<span class="badge badge--accent">−' + pct + '%</span>' : "") + (envio ? '<span class="badge badge--navy">Envío gratis RM</span>' : "") + '</span>';
    return (
      '<a class="card' + (soldout && !pv ? " card--soldout" : "") + (pv ? " card--preventa" : "") + '" href="' + p.url + '" data-qv-banned="false"' + (alt ? ' data-alt="' + escHtml(alt) + '"' : "") + '>' +
      '<div class="card__media">' + badges +
      '<div class="card__actions">' +
      '<button type="button" class="card__fav is-fav" data-fav="' + escHtml(p.handle) + '" aria-label="Quitar de favoritos" aria-pressed="true" onclick="event.preventDefault()">' + ICON_HEART + '</button>' +
      '<button type="button" class="card__quickview" data-quickview="' + escHtml(p.handle) + '" aria-label="Vista rápida de ' + escHtml(p.title) + '" onclick="event.preventDefault()">' + ICON_EYE + '</button>' +
      '</div>' +
      '<img src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy">' +
      '</div>' +
      '<div class="card__body">' +
      '<span class="card__brand">' + escHtml(vendor) + (verified ? ICON_VERIFIED : "") + '</span>' +
      '<span class="card__title">' + escHtml(p.title) + '</span>' +
      '<div class="card__price-row">' +
      (before > price ? '<span class="card__before">' + clp(before) + '</span>' : "") +
      '<span class="card__price">' + clp(price) + '</span>' +
      (pv || !soldout ? '<span class="card__cuotas">' + n + 'x ' + clp(cuota) + ' sin interés</span>' : '<span class="card__soldout-flag">Sin stock por ahora</span>') +
      '</div>' +
      (pv ? '<span class="card__cta">Reservar</span>' : (!soldout ? ((p.variants || []).length > 1
        ? '<button type="button" class="card__cta" data-quickview="' + escHtml(p.handle) + '" data-qv-choose="true" aria-label="Elegir opciones de ' + escHtml(p.title) + '" onclick="event.preventDefault()">Elegir opciones</button>'
        : '<button type="button" class="card__cta" data-add-variant="' + v.id + '" aria-label="Agregar ' + escHtml(p.title) + ' al carrito" onclick="event.preventDefault()">Agregar al carrito</button>') : '<span class="card__cta">Ver ficha</span>')) +
      '</div></a>'
    );
  }

  // ------------------------------------------------------------ quickview --
  function openQuickView(handle, banned) {
    var modal = document.getElementById("drQuickView");
    var body = document.getElementById("drQuickViewBody");
    if (!modal || !body) return;
    body.innerHTML = '<p style="padding:40px;text-align:center">Cargando…</p>';
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variants = p.variants || [];
        var multi = variants.length > 1;
        // UX 14-09: la variante inicial es la primera DISPONIBLE (no la primera a
        // ciegas) y, si hay más de una, el usuario elige antes de agregar.
        var v = firstAvailableVariant(p) || variants[0] || {};
        var soldout = !p.available;
        var pv = esPreventa(p);
        var n = parseInt((S.installments || 6), 10) || 6;
        function priceHtml(vv) {
          var pct = 0;
          if (vv.compare_at_price && vv.compare_at_price > vv.price) {
            pct = Math.round((1 - vv.price / vv.compare_at_price) * 100);
            if (pct < 15 || pct > 55) pct = 0;
          }
          var cuota = Math.ceil((vv.price / n) / 1000) * 1000;
          return '<div class="price-row">' +
            (vv.compare_at_price > vv.price ? '<span class="before">' + clp(vv.compare_at_price) + '</span>' : "") +
            '<span class="price">' + clp(vv.price) + '</span>' +
            (pct ? '<span class="badge badge--accent">−' + pct + '%</span>' : "") +
            '</div>' +
            (vv.available ? '<div class="pdp-cuotas">' + n + 'x ' + clp(cuota) + ' sin interés</div>' : '<div class="card__soldout-flag">Sin stock por ahora</div>');
        }
        var optionLabel = (p.options && p.options.length) ? p.options.map(function (o) { return (o && o.name) ? o.name : o; }).join(" / ") : "Opción";
        var selectHtml = multi
          ? '<div class="quickview__variant"><label for="drQvVariant">' + escHtml(optionLabel) + '</label>' +
            '<select id="drQvVariant" aria-describedby="drQvVariantHint">' +
            variants.map(function (vv) {
              return '<option value="' + vv.id + '"' + (vv.id === v.id ? ' selected' : '') + (vv.available ? '' : ' disabled') + '>' + escHtml(vv.title) + ' · ' + clp(vv.price) + (vv.available ? '' : ' · Agotado') + '</option>';
            }).join("") +
            '</select><p class="field-hint" id="drQvVariantHint">Elige la opción correcta antes de agregar.</p></div>'
          : "";
        body.innerHTML =
          '<div class="quickview__media"><img src="' + (p.featured_image || "") + '" alt="' + escHtml(p.title) + '"></div>' +
          '<div class="quickview__info">' +
          '<span class="card__brand">' + escHtml(p.vendor || "") + '</span>' +
          '<h3>' + escHtml(p.title) + '</h3>' +
          '<div id="drQvPrice">' + priceHtml(v) + '</div>' +
          selectHtml +
          '<div class="cta">' +
          (!soldout && !pv && banned !== "true" ? '<button type="button" class="btn btn-primary btn-lg" id="drQvAdd" data-add-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>Agregar al carro</button>' : "") +
          '<a class="btn ' + (banned === "true" || soldout || pv ? "btn-primary" : "btn-ghost") + ' btn-lg" href="' + p.url + '">' + (pv ? "Ver ficha y reservar" : "Ver ficha completa") + '</a>' +
          '</div>' +
          (pv ? '<p class="quickview__note">Este producto está en preventa: todavía no está en bodega. En la ficha te decimos para cuándo llega antes de que reserves.</p>' : "") +
          (banned === "true" ? '<p class="quickview__note">Este producto depende de la medida y el contexto clínico de quien lo va a usar — te recomendamos ver la ficha completa antes de comprar.</p>' : "") +
          '</div>';
        var sel = document.getElementById("drQvVariant");
        if (sel) {
          sel.addEventListener("change", function () {
            var vv = variants.filter(function (x) { return String(x.id) === sel.value; })[0];
            if (!vv) return;
            var priceBox = document.getElementById("drQvPrice");
            if (priceBox) priceBox.innerHTML = priceHtml(vv);
            var add = document.getElementById("drQvAdd");
            if (add) { add.setAttribute("data-add-variant", vv.id); add.disabled = !vv.available; }
          });
        }
      })
      .catch(function () { body.innerHTML = '<p style="padding:40px;text-align:center">No pudimos cargar este producto.</p>'; });
  }
  function closeQuickView() {
    var modal = document.getElementById("drQuickView");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  // ------------------------------- lo que la persona viene mirando (19-10) --
  // El historial vive en el navegador de quien compra (localStorage), nunca sale
  // de ahí y no se cruza con nadie. Alimenta dos rieles: "sigue donde quedaste"
  // (las últimas fichas que miró) y "porque viste X" (recomendaciones NATIVAS de
  // Shopify sobre la última ficha, vía /recommendations/products).
  var VIS_KEY = "dr_vistos";
  var VIS_MAX = 12;
  function vistos() {
    try { return JSON.parse(localStorage.getItem(VIS_KEY) || "[]").filter(function (x) { return x && x.h; }); }
    catch (e) { return []; }
  }
  function registrarVisto(h, id, titulo) {
    if (!h) return;
    var l = vistos().filter(function (x) { return x.h !== h; });
    l.unshift({ h: h, id: id, t: titulo || "", ts: Date.now() });
    try { localStorage.setItem(VIS_KEY, JSON.stringify(l.slice(0, VIS_MAX))); } catch (e) {}
  }
  function initHistorial() {
    var pdp = qs("[data-dr-product]");
    if (!pdp) return;
    registrarVisto(pdp.getAttribute("data-dr-product"), pdp.getAttribute("data-dr-pid"), pdp.getAttribute("data-dr-title"));
  }
  function initPerso() {
    var rieles = qsa(".dr-perso");
    if (!rieles.length) return;
    var pdp = qs("[data-dr-product]");
    var actual = pdp ? pdp.getAttribute("data-dr-product") : null;
    var hist = vistos().filter(function (x) { return x.h !== actual; });

    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-perso-limpiar]")) return;
      try { localStorage.removeItem(VIS_KEY); } catch (err) {}
      qsa(".dr-perso").forEach(function (r) { r.classList.remove("is-on"); });
      toast("Listo, borramos tu historial");
    });

    // Riel 1 — las últimas fichas que miró, pintadas con la misma tarjeta del sitio.
    var rVistos = qs('.dr-perso[data-perso="vistos"]');
    if (rVistos && hist.length >= 2) {
      var faltan = hist.slice(0, 4);
      Promise.all(faltan.map(function (x) {
        return fetch("/products/" + x.h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        var html = ps.filter(Boolean).map(favCardHtml).join("");
        if (!html) return;
        var grid = qs("[data-perso-grid]", rVistos);
        grid.innerHTML = html;
        syncFavButtons(grid);
        rVistos.classList.add("is-on");
      });
    }

    // Riel 2 — "porque viste X": recomendaciones nativas de Shopify sobre la última ficha.
    var rReco = qs('.dr-perso[data-perso="reco"]');
    var ultimo = hist[0];
    if (rReco && ultimo && ultimo.id) {
      fetch("/recommendations/products?section_id=drcare-reco&limit=4&intent=related&product_id=" + encodeURIComponent(ultimo.id))
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var cuerpo = (html || "").trim();
          if (cuerpo.indexOf("card") === -1) return;
          var grid = qs("[data-perso-grid]", rReco);
          // La Section Rendering API devuelve las tarjetas envueltas en un
          // <div class="shopify-section">. Si se deja, ese div es el único hijo
          // del grid y las 4 tarjetas quedan apiladas en una columna (medido:
          // 2.522 px de alto). Se saca el envoltorio y se cuelgan las tarjetas.
          grid.innerHTML = cuerpo;
          var envoltorio = qs(".shopify-section", grid) || (grid.children.length === 1 && grid.firstElementChild.id && grid.firstElementChild.id.indexOf("shopify-section") === 0 ? grid.firstElementChild : null);
          if (envoltorio) {
            while (envoltorio.firstChild) grid.insertBefore(envoltorio.firstChild, envoltorio);
            envoltorio.remove();
          }
          var que = qs("[data-perso-que]", rReco);
          if (que) que.textContent = (ultimo.t || "").replace(/\s+/g, " ").trim().slice(0, 48) || "eso";
          syncFavButtons(grid);
          rReco.classList.add("is-on");
        })
        .catch(function () {});
    }
  }

  // ------------------------------------------- 2ª foto en hover (14-10) --
  // Cada tarjeta trae la segunda foto en data-alt (Liquid) y el <img> se crea
  // RECIÉN en el primer hover de mouse: en celular no hay hover, así que no se
  // descarga ni un byte extra. Delegado en document para que valga también en
  // las tarjetas que se repintan por JS (filtros en vivo, favoritos). La ficha
  // no entra: ahí la galería ya manda.
  function initCardHoverAlt() {
    document.addEventListener("pointerover", function (e) {
      if (e.pointerType && e.pointerType !== "mouse") return;
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest(".card[data-alt]");
      if (!card || card.dataset.altDone) return;
      var src = card.getAttribute("data-alt");
      var media = card.querySelector(".card__media");
      if (!src || !media) return;
      card.dataset.altDone = "1";
      var img = document.createElement("img");
      img.className = "card__media-alt";
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      img.decoding = "async";
      // El fundido arranca cuando la foto YA está cargada (si no, aparece de golpe).
      img.addEventListener("load", function () { img.classList.add("is-ready"); });
      img.addEventListener("error", function () { img.remove(); });
      img.src = src;
      media.appendChild(img);
    }, { passive: true });
  }

  function initCardInteractions() {
    document.addEventListener("click", function (e) {
      var favBtn = e.target.closest("[data-fav]");
      if (favBtn) {
        e.preventDefault();
        var saved = toggleFav(favBtn.getAttribute("data-fav"));
        favBtn.classList.toggle("is-fav", saved);
        favBtn.setAttribute("aria-pressed", String(saved));
        toast(saved ? "Guardado en tus favoritos" : "Quitado de tus favoritos");
        return;
      }
      var qvBtn = e.target.closest("[data-quickview]");
      if (qvBtn) {
        e.preventDefault();
        var card = qvBtn.closest(".card");
        openQuickView(qvBtn.getAttribute("data-quickview"), card ? card.getAttribute("data-qv-banned") : "false");
        return;
      }
      if (e.target.closest("[data-close-quickview]")) closeQuickView();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeQuickView(); });
    syncFavButtons(document);
  }
  function syncFavButtons(root) {
    qsa("[data-fav]", root).forEach(function (btn) {
      var on = isFav(btn.getAttribute("data-fav"));
      btn.classList.toggle("is-fav", on);
      btn.setAttribute("aria-pressed", String(on));
    });
  }

  // --------------------------------------------------------- carro (AJAX) --
  function addToCart(variantId, qty) {
    return fetch(S.routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function addMultipleToCart(items) {
    return fetch(S.routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); }).then(function (data) { refreshCartCount(); return data; });
  }
  // "Tu carro (3)" en el título del drawer (21-09, pedido del cliente)
  function setDrawerTitleCount(n) {
    var t = document.getElementById("drCartTitleCount");
    if (!t) return;
    t.textContent = n > 0 ? "(" + n + ")" : "";
  }
  function refreshCartCount() {
    return fetch(S.routes.cart)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById("drCartCount");
        if (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        }
        setDrawerTitleCount(cart.item_count);
        return cart;
      });
  }

  function shipBoxHtml(cart) {
    var threshold = S.shippingThresholdCents || 0;
    var remaining = threshold - cart.total_price;
    var pct = threshold > 0 ? Math.max(0, Math.min(100, (cart.total_price / threshold) * 100)) : 100;
    var region = S.shippingRegionLabel || S.shippingRegionLong || "RM"; // 29-09: en el drawer, sigla corta
    if (remaining <= 0) {
      return (
        '<div class="shipping-ok">' + iconTruck() + ' ¡Tu pedido ya tiene envío gratis en ' + region + '!</div>' +
        '<div class="shipping-progress" style="margin-top:10px"><div class="shipping-progress__fill" style="width:100%"></div></div>'
      );
    }
    return (
      '<div class="shipping-bar__head">' + iconTruck() + ' Te faltan ' + clp(remaining) + ' para envío gratis en ' + region + '</div>' +
      '<div class="shipping-progress"><div class="shipping-progress__fill" style="width:' + pct + '%"></div></div>' +
      '<div id="drShipSuggest"></div>'
    );
  }
  function iconTruck() {
    return '<svg class="dr-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="19" r="1.6"/><circle cx="17" cy="19" r="1.6"/></svg>';
  }

  // ------------------------- sugerencia de envío gratis (drawer, real) -----
  // Mismo algoritmo que snippets/drcare-pdp-shipping-bar.liquid y
  // snippets/drcare-cart-shipping-bar.liquid (single-fit / combo de UNA sola
  // acción / "no alcanza, esto sí podría servirte" sin prometer), pero acá
  // corre en JS porque el drawer se arma con fetch a /cart.js, no en Liquid.
  // Ventaja real sobre la versión de la PDP: acá SÍ se excluye lo que ya
  // está en el carro (no hay tope de `all_products`, se puede pedir
  // /products/{handle}.js solo para los 1-4 handles elegidos al final).
  function parseFillerHandles(cartHandles) {
    var raw = S.shippingFillerHandles || "";
    var excluded = {};
    (cartHandles || []).forEach(function (h) { excluded[h] = true; });
    return raw.split(",").map(function (pair) {
      var parts = pair.trim().split(":");
      return { handle: parts[0], priceCents: (parseInt(parts[1], 10) || 0) * 100 };
    }).filter(function (c) { return c.handle && !excluded[c.handle]; });
  }
  function fetchProductsByHandle(handles) {
    return Promise.all(handles.map(function (h) {
      return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      // 19-10 — Fuera los que están en preventa: no sirven para "completa el
      // monto y tienes envío gratis" si no se despachan hoy, y agregarlos desde
      // acá perdería la marca de preventa del pedido.
      return list.filter(Boolean).filter(function (p) { return !esPreventa(p); });
    });
  }
  function firstAvailableVariant(p) {
    var list = p.variants || [];
    for (var i = 0; i < list.length; i++) { if (list[i].available) return list[i]; }
    return list[0];
  }
  function suggestCardHtml(p) {
    var v = firstAvailableVariant(p);
    var img = p.featured_image ? ("https:" + p.featured_image).replace(/^https:https:/, "https:") : "";
    if (img && img.indexOf("width=") === -1) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=92";
    return (
      '<button type="button" class="shipping-suggest" data-add-variant="' + v.id + '" style="width:100%;text-align:left;border:none;cursor:pointer;margin-bottom:6px">' +
      '<img src="' + img + '" width="46" height="46" alt="" loading="lazy">' +
      '<span class="shipping-suggest__info"><span class="t">' + escHtml(p.title) + '</span><span class="p">' + clp(v.price) + '</span></span>' +
      '<span class="btn btn-ghost" style="pointer-events:none">Agregar</span></button>'
    );
  }
  // Barra de envío gratis del drawer calculada en Liquid (Section Rendering
  // API sobre sections/drcare-cart-suggest.liquid → mismo snippet que /cart).
  function renderShippingServer() {
    var shipBox = document.getElementById("drCartShipBox");
    if (!shipBox) return Promise.resolve(false);
    return fetch("/?sections=drcare-cart-suggest", { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j["drcare-cart-suggest"];
        if (!html) return false;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var bar = tmp.querySelector(".shipping-bar");
        if (!bar || !bar.innerHTML.trim()) return false;
        shipBox.innerHTML = bar.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  }
  function renderShippingSuggestion(cart) {
    // Solo aplica al drawer (fetch-based). La página /cart calcula todo esto
    // server-side en snippets/drcare-cart-shipping-bar.liquid — mismo
    // algoritmo, sin necesitar JS.
    var holder = document.getElementById("drShipSuggest");
    if (!holder) return;
    var threshold = S.shippingThresholdCents || 0;
    var remaining = threshold - cart.total_price;
    if (threshold <= 0 || remaining <= 0) { holder.innerHTML = ""; return; }
    var cartHandles = cart.items.map(function (i) { return i.handle; });
    var candidates = parseFillerHandles(cartHandles); // ya vienen ordenados de menor a mayor precio
    var single = null;
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].priceCents >= remaining) { single = candidates[i]; break; }
    }
    if (single) {
      fetchProductsByHandle([single.handle]).then(function (list) {
        if (list[0]) holder.innerHTML = suggestCardHtml(list[0]);
      });
      return;
    }
    // combo: acumula desde el más caro, hasta 4 ítems
    var desc = candidates.slice().reverse();
    var chosen = [], sum = 0, reached = false;
    for (var j = 0; j < desc.length && chosen.length < 4 && !reached; j++) {
      chosen.push(desc[j]);
      sum += desc[j].priceCents;
      if (sum >= remaining) reached = true;
    }
    if (!chosen.length) { holder.innerHTML = ""; return; }
    fetchProductsByHandle(chosen.map(function (c) { return c.handle; })).then(function (list) {
      if (!list.length) { holder.innerHTML = ""; return; }
      if (reached) {
        var ids = list.map(function (p) { return firstAvailableVariant(p).id; }).join(",");
        var itemsHtml = list.map(function (p) {
          var v = firstAvailableVariant(p);
          var img = p.featured_image ? ("https:" + p.featured_image) : "";
          if (img && img.indexOf("width=") === -1) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=92";
          return '<div class="shipping-combo__item"><img src="' + img + '" width="46" height="46" alt="" loading="lazy">' +
            '<span class="shipping-suggest__info"><span class="t">' + escHtml(p.title) + '</span><span class="p">' + clp(v.price) + '</span></span></div>';
        }).join("");
        var label = list.length === 2 ? "los 2" : "los " + list.length;
        holder.innerHTML = '<div class="shipping-combo">' + itemsHtml +
          '<button type="button" class="btn btn-secondary shipping-combo__cta" data-add-variants="' + ids + '">Agregar ' + label + ' (' + clp(sum) + ') y obtener envío gratis</button></div>';
      } else {
        holder.innerHTML = '<p class="field-hint" style="margin-bottom:8px">No tenemos un combo que alcance a la medida, pero esto sí podría servirte:</p>' +
          '<div class="ship-sugs">' + list.slice(0, 3).map(suggestCardHtml).join("") + '</div>';
      }
    });
  }

  // Plegar / desplegar "Arma tu equipamiento" a mano
  function initCrossToggle() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-cross-toggle]");
      if (!t) return;
      var box = t.closest(".cart-drawer__cross");
      if (!box) return;
      var plegado = box.classList.toggle("is-collapsed");
      box.dataset.tocado = "1"; // si el cliente lo abre o lo cierra, se respeta su decisión
      t.setAttribute("aria-expanded", plegado ? "false" : "true");
    });
  }

  // --------------------------------- cross-sell del drawer (real) ----------
  // Recomendaciones nativas de Shopify (/recommendations/products.json,
  // basadas en ventas/tags reales de la tienda, sin backend propio) sobre el
  // último producto agregado al carro. "Visible sin scrollear": va ENTRE las
  // líneas y el pie del drawer, que son flex:none — solo .cart-drawer__body
  // hace scroll interno (ver assets/drcare.css §16).
  function renderCartCrossSell(cart) {
    var box = document.getElementById("drCartCross");
    var scroll = document.getElementById("drCartCrossScroll");
    if (!box || !scroll) return;
    if (!cart.items.length) { box.hidden = true; return; }
    var last = cart.items[cart.items.length - 1];
    var cartIds = {};
    cart.items.forEach(function (i) { cartIds[i.product_id] = true; });
    fetch("/recommendations/products.json?product_id=" + last.product_id + "&limit=8&intent=related")
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        // 19-10: fuera lo que está en preventa — este bloque agrega al carro con un
        // clic y perdería la marca del pedido; además no se despacha junto a lo demás.
        var list = (data.products || []).filter(function (p) { return !cartIds[p.id] && p.available && !esPreventa(p); }).slice(0, 8);
        if (!list.length) { box.hidden = true; return; }
        box.hidden = false;
        // 30-09 (José Tomás): con 2+ unidades y en escritorio, el bloque arranca plegado.
        // El cliente ya sabe del descuento por la línea del pie, y así el carro muestra lo comprado.
        var plegar = (cart.item_count || 0) >= 2 && window.innerWidth >= 901;
        if (!box.dataset.tocado) {
          box.classList.toggle("is-collapsed", plegar);
          var tg = box.querySelector("[data-cross-toggle]");
          if (tg) tg.setAttribute("aria-expanded", plegar ? "false" : "true");
        }
        scroll.innerHTML = list.map(function (p) {
          var v = firstAvailableVariant(p);
          var img = p.images && p.images[0] ? ("https:" + p.images[0]) : "";
          if (img && img.indexOf("width=") === -1) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=160";
          return '<button type="button" class="cart-cross-item" data-add-variant="' + v.id + '">' +
            '<img src="' + img + '" alt="" loading="lazy">' +
            '<div class="t">' + escHtml(p.title) + '</div><div class="p">' + clp(v.price) + '</div></button>';
        }).join("");
      })
      .catch(function () { box.hidden = true; });
  }

  function renderCartDrawer() {
    var body = document.getElementById("drCartBody");
    var shipBox = document.getElementById("drCartShipBox");
    var subtotalEl = document.getElementById("drCartSubtotal");
    var waBtn = document.getElementById("drBtnCartWa");
    if (!body) return;
    fetch(S.routes.cart).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-empty">Tu carro está vacío.<br><a href="/collections/all" class="btn btn-ghost" style="margin-top:14px">Ver productos</a></div>';
      } else {
        body.innerHTML = cart.items.map(function (line, i) {
          return (
            '<div class="cart-line" data-line="' + (i + 1) + '">' +
            '<img src="' + (line.image || "") + '" alt="" loading="lazy">' +
            '<div class="cart-line__info">' +
            '<div class="cart-line__title">' + escHtml(line.product_title) + '</div>' +
            '<div class="cart-line__price">' + clp(line.final_line_price) + '</div>' +
            '<div class="cart-line__qty">' +
            '<button type="button" data-qty="-1" aria-label="Restar">−</button>' +
            '<span class="num">' + line.quantity + '</span>' +
            '<button type="button" data-qty="1" aria-label="Sumar">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-remove>Quitar</button>' +
            '</div></div>'
          );
        }).join("");
      }
      if (shipBox) shipBox.innerHTML = shipBoxHtml(cart);
      if (cart.items.length) {
        // Primero el cálculo server-side (misma pertinencia que /cart, con
        // colecciones y mapa de afinidad); si la API falla, el JS de siempre.
        renderShippingServer().then(function (ok) { if (!ok) renderShippingSuggestion(cart); });
      }
      renderCartCrossSell(cart);
      if (subtotalEl) subtotalEl.textContent = clp(cart.total_price);
      // El cupón de Mercado Pago pide un mínimo: que el bloque se entere del subtotal nuevo.
      document.dispatchEvent(new CustomEvent("dr:cart", { detail: cart }));
      // Descuento automático de Shopify (ej. "Arma tu equipo: 5 %"): las líneas
      // muestran precio original, así que sin esta fila el subtotal no cuadra.
      var discRow = document.getElementById("drCartDiscount");
      if (discRow) {
        var disc = cart.total_discount || 0;
        var apps = cart.cart_level_discount_applications || [];
        discRow.hidden = !(disc > 0);
        if (disc > 0) {
          var lbl = document.getElementById("drCartDiscountLabel");
          if (lbl) lbl.textContent = apps.length && apps[0].title ? apps[0].title : "Descuento";
          discRow.querySelector(".amt").textContent = "−" + clp(disc);
        }
      }
      if (waBtn && S.whatsappNumber) {
        var msg = cart.items.length
          ? "Hola, quiero confirmar este pedido:\n" + cart.items.map(function (l) { return "• " + l.quantity + "x " + l.product_title + " — " + clp(l.final_line_price); }).join("\n") + "\nSubtotal: " + clp(cart.total_price)
          : "Hola, quiero armar un pedido con ayuda.";
        waBtn.href = "https://wa.me/" + S.whatsappNumber + "?text=" + encodeURIComponent(msg);
      }
      var countEl = document.getElementById("drCartCount");
      if (countEl) { countEl.textContent = cart.item_count; countEl.hidden = cart.item_count === 0; }
      setDrawerTitleCount(cart.item_count);
    });
  }

  function openCartDrawer() {
    var d = document.getElementById("drCartDrawer");
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    renderCartDrawer();
  }
  // Maqueta (js/cart.js): agregar desde tarjeta, quick view, buscador o
  // cross-sell muestra SOLO el toast; no abre el drawer. Si el drawer ya está
  // abierto (cross-sell / sugerencia de envío dentro del drawer), se re-pinta.
  function afterAdd() {
    var d = document.getElementById("drCartDrawer");
    if (d && d.classList.contains("is-open")) renderCartDrawer(); else refreshCartCount();
  }
  function closeCartDrawer() {
    var d = document.getElementById("drCartDrawer");
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function initCart() {
    document.addEventListener("click", function (e) {
      if (e.target.closest("#drBtnOpenCart")) { openCartDrawer(); return; }
      if (e.target.closest("[data-close-cart]")) { closeCartDrawer(); return; }

      // Página /cart (sections/drcare-cart.liquid): +/- SOLO mueven el
      // <input type=number> del formulario nativo `updates[]` — sin fetch,
      // el cambio real se aplica al enviar "Actualizar carro" o "Finalizar
      // compra". Distinto a expósito del drawer (data-qty), que sí es AJAX.
      var stepBtn = e.target.closest("[data-qty-step]");
      if (stepBtn) {
        var input = document.getElementById(stepBtn.getAttribute("data-target"));
        if (input) {
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute("data-qty-step"), 10));
          input.value = next;
        }
        return;
      }

      // Combo de envío gratis (varios ítems en UNA acción). Vive acá, en el
      // script global, porque el botón aparece en el drawer y en /cart, donde
      // drcare-shop.js no se carga. Marca el evento para no duplicar con
      // initShippingCombo() de drcare-shop.js en ficha/colección/búsqueda.
      var comboBtn = e.target.closest("[data-add-variants]");
      if (comboBtn && !e.drComboHandled) {
        e.drComboHandled = true;
        e.preventDefault();
        var ids = (comboBtn.getAttribute("data-add-variants") || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);
        if (!ids.length) return;
        comboBtn.disabled = true;
        fetch(S.routes.cartAdd, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }),
        })
          .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
          .then(function () { toast("Agregados al carro"); afterAdd(); })
          .catch(function () { toast("No pudimos agregarlos — revisa el stock"); })
          .then(function () { comboBtn.disabled = false; });
        return;
      }
      var addBtn = e.target.closest("[data-add-variant]");
      if (addBtn) {
        e.preventDefault();
        var vid = addBtn.getAttribute("data-add-variant");
        if (!vid) return;
        addBtn.disabled = true;
        addToCart(vid, 1)
          .then(function () { toast("Agregado al carro"); afterAdd(); })
          .catch(function () { toast("No pudimos agregarlo — revisa el stock"); })
          .then(function () { addBtn.disabled = false; });
        return;
      }
      var qtyBtn = e.target.closest("[data-qty]");
      if (qtyBtn) {
        var line = qtyBtn.closest(".cart-line");
        var lineNo = parseInt(line.getAttribute("data-line"), 10);
        var delta = parseInt(qtyBtn.getAttribute("data-qty"), 10);
        var currentNum = parseInt(qs(".num", line).textContent, 10) || 0;
        var next = Math.max(0, currentNum + delta);
        fetch(S.routes.cartChange, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: lineNo, quantity: next }),
        }).then(renderCartDrawer);
        return;
      }
      var removeBtn = e.target.closest("[data-remove]");
      if (removeBtn) {
        var l2 = removeBtn.closest(".cart-line");
        var lineNo2 = parseInt(l2.getAttribute("data-line"), 10);
        fetch(S.routes.cartChange, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: lineNo2, quantity: 0 }),
        }).then(renderCartDrawer);
        return;
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCartDrawer(); });
    refreshCartCount();
  }

  // Filtros en vivo de /search — réplica de initLiveFilters (drcare-shop.js)
  // para #drSearchMain, que además arrastra los parámetros base (q, type).
  function initLiveFiltersSearch() {
    if (!document.getElementById("drSearchMain")) return;
    // En búsqueda el Liquid no conoce los parámetros de precio (search.filters
    // no trae price_range), así que el estado de los tramos se restaura desde la URL.
    function syncBucketsFromUrl() {
      var sp = new URLSearchParams(location.search);
      var gte = parseInt(sp.get("filter.v.price.gte"), 10) || 0;
      var lte = parseInt(sp.get("filter.v.price.lte"), 10) || 0;
      qsa("[data-price-bucket]").forEach(function (b) {
        var bmin = parseInt(b.getAttribute("data-min"), 10) || 0;
        var bmax = parseInt(b.getAttribute("data-max"), 10) || 0;
        var on = (gte > 0 || lte > 0) && gte <= bmin && (lte === 0 || (bmax > 0 && lte >= bmax - 1));
        b.checked = on;
      });
    }
    syncBucketsFromUrl();
    function buildUrl() {
      var main = document.getElementById("drSearchMain");
      var form = document.getElementById("drFiltersForm");
      var params = new URLSearchParams(main.getAttribute("data-base") || "");
      if (form) {
        var buckets = qsa("[data-price-bucket]:checked", form);
        if (buckets.length) {
          var mins = buckets.map(function (b) { return parseInt(b.getAttribute("data-min"), 10) || 0; });
          var maxes = buckets.map(function (b) { return parseInt(b.getAttribute("data-max"), 10) || 0; });
          var min = Math.min.apply(null, mins);
          var max = maxes.indexOf(0) !== -1 ? 0 : Math.max.apply(null, maxes);
          var gte = form.querySelector("[data-price-gte]");
          var lte = form.querySelector("[data-price-lte]");
          if (gte && min > 0) params.append(gte.name, String(min));
          if (lte && max > 0) params.append(lte.name, String(max - 1));
        }
        qsa("input[name]", form).forEach(function (i) {
          if (i.type === "hidden") return;
          if ((i.type === "checkbox" || i.type === "radio") && i.checked && i.value !== "") params.append(i.name, i.value);
        });
      }
      var sort = document.getElementById("drSortSelect");
      if (sort && sort.value && sort.value !== sort.getAttribute("data-default")) params.append("sort_by", sort.value);
      return main.getAttribute("data-url") + "?" + params.toString();
    }
    function load(url, push) {
      var main = document.getElementById("drSearchMain");
      if (!main) return Promise.resolve();
      var sid = main.getAttribute("data-section-id");
      main.style.opacity = ".55";
      return fetch(url + "&sections=" + encodeURIComponent(sid), { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("http"); return r.json(); })
        .then(function (j) {
          var html = j[sid];
          if (!html) throw new Error("sin seccion");
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("#drSearchMain");
          if (!fresh) throw new Error("sin main");
          main.replaceWith(fresh);
          if (push) history.pushState({ drSearch: true }, "", url);
          syncBucketsFromUrl();
          var scrim = document.getElementById("filtersScrim");
          if (scrim) scrim.classList.remove("is-open");
        })
        .catch(function () { window.location.href = url; });
    }
    document.addEventListener("change", function (e) {
      if (e.target.closest("#drFiltersForm") || e.target.id === "drSortSelect") load(buildUrl(), true);
    });
    document.addEventListener("click", function (e) {
      var clear = e.target.closest("#btnClearFilters, #btnClearFilters2");
      if (!clear) return;
      e.preventDefault();
      var main = document.getElementById("drSearchMain");
      if (main) load(main.getAttribute("data-url") + "?" + (main.getAttribute("data-base") || ""), true);
    });
    window.addEventListener("popstate", function () {
      if (document.getElementById("drSearchMain")) load(location.pathname + location.search, false);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Accesibilidad (UX 14-09): los contadores del header anuncian sus cambios.
    ["drCartCount", "drFavCount"].forEach(function (id) { var el = document.getElementById(id); if (el) { el.setAttribute("aria-live", "polite"); el.setAttribute("aria-atomic", "true"); } });
    ensureUnderlines();
    initReveal();
    initPromoCarousel();
    initDragScroll();
    initScrolledFlag();
    initSameDay();
    initCyber();
    initPromoMp();
    initCrossToggle();
    initHero();
    initTabs();
    initCarouselArrows();
    initScenarios();
    initMobileMenu();
    initSearch();
    initCardInteractions();
    initCardHoverAlt();
    initHistorial();
    initPerso();
    initCart();
    updateFavCount();
    renderFavoritesPage();
    initLiveFiltersSearch();
  });
})();
